import i18next from 'i18next';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchBodyAreas,
  fetchDevices,
  fetchTreatmentCategories,
  fetchTreatments,
} from '@/api/treatmentLibrary/treatmentLibraryApi';
import type {
  BodyArea,
  Device,
  Treatment,
  TreatmentCategory,
} from '@/api/treatmentLibrary/treatmentLibraryApi.types';
import {
  BODY_AREAS_QUERY_KEY,
  TREATMENTS_QUERY_KEY,
  TREATMENT_CATEGORIES_QUERY_KEY,
  TREATMENT_DEVICES_QUERY_KEY,
} from '@/constants/queryKeys';

export function useDevicesQuery(isEnabled: boolean): UseQueryResult<Device[], Error> {
  return useQuery({
    queryKey: [...TREATMENT_DEVICES_QUERY_KEY, i18next.language],
    queryFn: fetchDevices,
    enabled: isEnabled,
  });
}

export function useTreatmentCategoriesQuery(
  isEnabled: boolean
): UseQueryResult<TreatmentCategory[], Error> {
  return useQuery({
    queryKey: [...TREATMENT_CATEGORIES_QUERY_KEY, i18next.language],
    queryFn: fetchTreatmentCategories,
    enabled: isEnabled,
  });
}

export function useBodyAreasQuery(isEnabled: boolean): UseQueryResult<BodyArea[], Error> {
  return useQuery({
    queryKey: [...BODY_AREAS_QUERY_KEY, i18next.language],
    queryFn: fetchBodyAreas,
    enabled: isEnabled,
  });
}

export function useTreatmentsQuery(
  search: string,
  categoryId: string | null,
  includeInactive: boolean,
  isEnabled: boolean
): UseQueryResult<Treatment[], Error> {
  return useQuery({
    queryKey: [...TREATMENTS_QUERY_KEY, i18next.language, search, categoryId, includeInactive],
    queryFn: function loadTreatments() {
      return fetchTreatments(search, categoryId, includeInactive);
    },
    enabled: isEnabled,
  });
}
